import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, ActivatedRoute } from '@angular/router'; // Add ActivatedRoute
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { VacationSwitchComponent } from 'src/app/shared/components/vacations/vacation-switch/vacation-switch.component';
import { OperationalCardComponent } from 'src/app/shared/components/vacations/operational-card/operational-card.component';
import { HolidaysService } from 'src/app/shared/services/holidays/holidays.service';
import {
  ExerciseResponse,
  OperativeResponse,
  OperativaGroup,
} from 'src/app/shared/interfaces/holidays.interface';

@Component({
  selector: 'app-exercise',
  imports: [
    LoaderComponent,
    MatIconModule,
    RouterLink,
    MatButtonModule,
    MatSlideToggleModule,
    MatTabGroup,
    MatTab,
    OperationalCardComponent,
    VacationSwitchComponent,
    RouterLink,
  ],
  templateUrl: './exercise.component.html',
  styleUrls: ['./exercise.component.css', '../../../shared/styles/layout.css'],
})
export class ExerciseComponent implements OnInit {
  public exercise?: ExerciseResponse;
  public data: (OperativeResponse | OperativaGroup)[] = [];

  constructor(
    private loaderService: LoaderService,
    private holidaysService: HolidaysService,
    private route: ActivatedRoute // Inject ActivatedRoute
  ) {
    // Remove the navigation state logic from constructor
  }

  ngOnInit(): void {
    this.loaderService.showLoader();
    // Get the exercise ID from route params and fetch data
    const exerciseId = this.route.snapshot.params['id'];
    if (exerciseId) {
      this.getExercise(exerciseId);
      this.getOperatives(exerciseId);
    }
  }

  getExercise(id: number) {
    this.holidaysService.getExerciseById(id, false).subscribe((exercise) => {
      this.exercise = exercise;
      // Store start_date in localStorage for use in operational-form readonly logic
      if (exercise.start_date) {
        localStorage.setItem('exercise_start_date', exercise.start_date);
      }
    });
  }

  getOperatives(id: number) {
    this.holidaysService.getExerciseOperatives(id).subscribe({
      next: (response) => {
        // console.log('Exercise operatives response:', response);

        // Check if operativa_groups exists and is an array
        if (!response || !Array.isArray(response.operativa_groups)) {
          console.warn(
            'No operativa_groups found in response or invalid format'
          );
          this.data = [];
          this.loaderService.hideLoader();
          return;
        }

        // Filter to show only active groups that have at least one operative with an active protocol_assignment
        this.data = response.operativa_groups.filter(
          (group) =>
            group.active &&
            !group.is_deleted &&
            group.operatives?.some(
              (op: any) => op.protocol_assignment?.status === 'active'
            )
        );

        // console.log('Filtered operative groups:', this.data.length);
        this.loaderService.hideLoader();
      },
      error: (err) => {
        console.error('Error fetching operatives:', err);
        console.error('Error details:', err.error);
        this.data = [];
        this.loaderService.hideLoader();
      },
    });
  }

  get isLoading(): boolean {
    return this.loaderService.getLoader();
  }

  syncOperatives(): void {
    this.loaderService.showLoader();
    this.holidaysService.syncOperatives().subscribe({
      next: () => {
        // console.log('Operatives synchronized successfully.');
        this.loaderService.hideLoader();
        // Refresh the operatives list after synchronization
        if (this.exercise) {
          this.getOperatives(this.exercise.id);
        }
      },
      error: (err) => {
        console.error('Error synchronizing operatives:', err);
        this.loaderService.hideLoader();
      },
    });
  }

  syncDrivers(): void {
    this.loaderService.showLoader();
    this.holidaysService.syncDrivers().subscribe({
      next: () => {
        // console.log('Drivers synchronized successfully.');
        this.loaderService.hideLoader();
        // Refresh the operatives list after synchronization
        if (this.exercise) {
          this.getOperatives(this.exercise.id);
        }
      },
      error: (err) => {
        console.error('Error synchronizing drivers:', err);
        this.loaderService.hideLoader();
      },
    });
  }
}
